module.exports = __webpack_public_path__ + "img/47_10.7b19d60f.png";